import { addSubVariantConfig } from '../core/rulesAddSubConfig';
import {
  type RulesAddSubFlag,
  createRulesAddSubProblemState,
  populateRulesAddSubProblems,
} from '../core/rulesAddSubProblems';

import {
  type RulesGame,
  type UseRulesFamilyGameOptions,
  useRulesBoardGame,
} from './useRulesBoardGame';

export type UseAddSubGameOptions = UseRulesFamilyGameOptions<RulesAddSubFlag>;

/**
 * Progression, pacing and problem selection for a VIF addition/subtraction
 * variant. A thin wrapper around the family-generic `useRulesBoardGame`,
 * supplying add/sub's config/problem-selection plumbing; see that hook's own
 * doc comment for the shared mechanics (layers/games/rounds, the countdown,
 * the layer-transition wipe, the "begin board" lifecycle).
 */
export function useAddSubGame(options: UseAddSubGameOptions): RulesGame {
  return useRulesBoardGame({
    ...options,
    resolveConfig: addSubVariantConfig,
    createProblemState: createRulesAddSubProblemState,
    populateProblems: populateRulesAddSubProblems,
  });
}
